import React, { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { verifyToken } from './auth';

const ProtectedRoute = ({ element: Element }) => {
  const { user, loading, checkAuth } = useAuth();
  const navigate = useNavigate();

  // ย้าย useEffect มาอยู่ก่อนเงื่อนไขใดๆ
  useEffect(() => {
    const verifyUserToken = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        localStorage.clear();
        navigate('/');
        return;
      }

      try {
        // await verifyToken();
      } catch (error) {
        console.error('ProtectedRoute error:', error);
        localStorage.clear();
        // navigate('/');
      }
    };
    verifyUserToken();
  }, [navigate]); // เพิ่ม dependency array

  // console.log('User: ', user);

  if (loading) {
    return <div>Loading...</div>;
  }

  // ถ้าต้องการเปิดใช้การตรวจสอบผู้ใช้ สามารถนำโค้ดนี้กลับมาใช้ได้
  // if (!user) {
  //   return <Navigate to="/" replace />;
  // }

  return Element ? (
    <Element>
      <Outlet />
    </Element>
  ) : (
    <Outlet />
  );
};

export default ProtectedRoute;
